// extracted by mini-css-extract-plugin
export var filterIncDec = "_48-0";
export var leftBorder = "_48-1";
export var rightBorder = "_48-2";
export var stringInput = "_48-3";